import {lazy, Suspense} from 'react';
import {Switch, useLocation} from 'react-router-dom';
import {map} from './RouteMap';
import PrivateRoute from './PrivateRoute';
import PageLoading from '../components/Common/PageLoading';
import Layout from '../containers/Layout';

const Dashboard = lazy(() => import('../containers/Dashboard'));
const Profile = lazy(() => import('../containers/Profile'));
const Map = lazy(() => import('../containers/Map'));
const ManagerOrder = lazy(() => import('../containers/Order/ManagerOrder'));
const Order = lazy(() => import('../containers/Order/UserOrder'));
const Tickets = lazy(() => import('../containers/Ticket/Tickets'));
const Organizations = lazy(() => import('../containers/Organization'));
const ShapeFileUpload = lazy(() => import('../containers/ShapeFileUpload'));

const DashboardRoutes = () => {
    const location = useLocation();

    return (
      <Layout>
        <Switch location={location}>
          <Suspense fallback={<PageLoading className="h-4/5"/>}>
            <PrivateRoute path={map.routes.dashboard} component={Dashboard} exact />
            <PrivateRoute path={map.routes.map} component={Map} exact />
            <PrivateRoute path={map.routes.managerOrders} component={ManagerOrder} exact />
            <PrivateRoute path={map.routes.orders} component={Order} exact />
            <PrivateRoute path={map.routes.tickets} component={Tickets} exact />
            <PrivateRoute path={map.routes.organizations} component={Organizations} exact />
            <PrivateRoute path={map.routes.shapeFileUpload} component={ShapeFileUpload} exact />
            <PrivateRoute path={map.routes.profile} component={Profile} exact />
          </Suspense>
        </Switch>
      </Layout>
    );
};

export default DashboardRoutes;
